import { render, staticRenderFns } from "./QLTurni.vue?vue&type=template&id=6ba2c809&scoped=true&"
import script from "./QLTurni.vue?vue&type=script&lang=js&"
export * from "./QLTurni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba2c809",
  null
  
)

export default component.exports